import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Router, NavigationEnd } from "@angular/router";
import { SettingsService } from "../../core/settings/settings.service";
import { Subscription } from "rxjs/Subscription";

export class TabInfo {
    group: string;
    label?: string;
    link: string;
    unremovable?: boolean;
    iconClass?: string;
    selected?: boolean;
}

@Injectable()
export class TabsService {

    private _tabs: TabInfo[];

    public currentTabs: BehaviorSubject<TabInfo[]>;
    public currentLink: string;
    public currentGroup: string;
    public currentTabsLength: number;
    public currentScroll: number = 0;
    public scrollStep: number = 2;

    private subscription: Subscription;

    static INSTANCE: TabsService = null;

    constructor(private router: Router, private settings: SettingsService) {
        this._tabs = JSON.parse(localStorage.getItem('tabs')) || [];
        this.currentTabs = new BehaviorSubject(null);

        if (!TabsService.INSTANCE) {
            // construct object
            TabsService.INSTANCE = this;

            this.subscription = this.router.events.filter((event) => {
                return event instanceof NavigationEnd;
            }).subscribe((event) => {
                this.currentLink = event['url'];
                this.currentGroup = this.getGroup(this.currentLink);
                this.getDefaultTabs(this.currentGroup).forEach(tab => this.addTab(tab));
                console.log({link: this.currentLink, group: this.currentGroup, tabs: this._tabs});
                this.nextCurrentTabs();
            })

        }
        return TabsService.INSTANCE;
    }

    addTab(tab: TabInfo) {
        //this.findTabSameObject(tab.link, tab.group);
        console.log('addtab', {tab});
        if (!this.findTab(tab.label, tab.link, tab.group)) {
            //console.log("onglet non trouvé dans le même mode",tab.label, tab.link, tab.group);
            const tab_same_object = this.findTabSameObject(tab.link, tab.group);
            if (!tab_same_object) {
                //console.log("onglet non trouvé même dans un mode différent",tab.label, tab.link, tab.group,tab_same_object);
            } else {
                console.log("onglet trouvé dans un mode différent : fermeture de longlet",tab_same_object)
                //Fermer l'onglet trouvé
                this.removeTab(tab_same_object);
            }
            this._tabs.push(tab);
            console.log('result tabs', {tabs: this._tabs});
            // localStorage.setItem('tabs', JSON.stringify(this._tabs));
            this.nextCurrentTabs();
        } else {
            console.log("onglet trouvé",tab.label, tab.link, tab.group);
        }

    }

    nextCurrentTabs() {

        let groupedTabs = this._tabs.filter((tab) => tab.group === this.currentGroup);

        let leftOver = null;

        if (this.currentScroll >= 0) {
            leftOver = groupedTabs.splice(0, this.currentScroll);
            groupedTabs.push(...leftOver);
        } else {
            leftOver = groupedTabs.splice(groupedTabs.length + this.currentScroll, - this.currentScroll);
            groupedTabs.unshift(...leftOver);
        }

        const currentTabs = groupedTabs.map((tab) => {
            if (tab.link === this.router.url || tab.link.endsWith('create')
                && this.router.url.startsWith(tab.link))
                    tab.selected = true;
            else tab.selected = false;
            return tab;
        });

        this.currentTabsLength = currentTabs.length;

        this.currentTabs.next(currentTabs);
        // Update localStorage
        localStorage.setItem('tabs', JSON.stringify(this._tabs));
    }

    getSelectedTabUrl(group: string) {

        const selected = this._tabs.filter(tab => {
            return tab.selected === true && tab.group === group
        })

        return selected.length > 0
            ? selected[0].link
            : `/${group}`;
    }

    removeTab(tab: TabInfo) {

        if (this.currentLink === tab.link) {
            this.router.navigate([`/${tab.group}`]);
        }
        this._tabs = this._tabs.filter((item) => {
            return !(item.link == tab.link);
        });

        this.nextCurrentTabs();
    }

    removeAllRemovableTabs() {
        // Supprime tous les onglets non fixes
        this._tabs = this._tabs.filter((item) => {
            console.log(item.unremovable);
            return item.unremovable === true ;
        });
    }
    moveRight() {
        this.currentScroll += this.scrollStep;
        if (this.currentScroll >= this.currentTabsLength) {
            this.currentScroll = 0;
        }
        this.nextCurrentTabs();
    }

    moveLeft() {
        this.currentScroll -= this.scrollStep;
        if (this.currentScroll <= -this.currentTabsLength) {
            this.currentScroll = 0;
        }
        this.nextCurrentTabs();
    }

    private findTabSameObject(link, group) {
        //PL Recherche s'il existe un onglet portant sur le même objet (qui peut être dans un autre mode show/edit)
        const tab_link = link.split("/");
        const ident_object = tab_link[3];
        const group_object = tab_link[1];
        const mode_ouverture = tab_link[2];
        const tabs = this._tabs
        .filter((tab) => group == tab.group
            && link.split("/")[1] == tab.link.split("/")[1]
            && link.split("/")[3] && (link.split("/")[3] == tab.link.split("/")[3]))
        return tabs.length > 0 ? tabs[0] : null;
    }

    private findTab(label, link, group) {
        const tabs = this._tabs
        .filter((tab) => group == tab.group && label == tab.label && link == tab.link)
        return tabs.length > 0 ? tabs[0] : null;
    }

    private getGroup(url) {
        return url
            .replace(new RegExp('\/[0-9]+[\/0-9]*'), '')
            .replace('/create', '')
            .replace('/edit', '')
            .replace('/show', '')
            .replace('/', ''); // replace first / in sequence
    }

    private getDefaultTabs(group) {
        let defaultTabs = [];
        switch (group) {
            case 'famille':
            case 'eleve':
            case 'professeur':
            case 'cours':
            case 'courriel':
            case 'sms':
            case 'administration/locations':
                const link = `/${group}/create`;
                if (this.settings.isUserRouteAllowed(link)) {
                    defaultTabs.push({
                        label: 'Création',
                        link,
                        unremovable: true,
                        iconClass: 'fa fa-user-plus',
                        group,
                    })
                }

                defaultTabs.push({
                    label: 'Recherche',
                    link: `/${group}`,
                    unremovable: true,
                    iconClass: 'fa fa-search',
                    group,
                });
                break;
            case 'bulletin':
                defaultTabs.push({
                    label: 'Recherche',
                    link: `/${group}`,
                    unremovable: true,
                    iconClass: 'fa fa-search',
                    group,
                });
                break;
        }
        return defaultTabs;
    }

}


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/services/tabs.service.ts